
export const formatDisplayValue = (value) => {
    if (typeof(value) === 'string') {
        return value;
    } else {
        return (isNaN(value) || value === 0 || !isFinite(value)) ? '' : value;
    }
};

// toFixed를 안전하게 사용
export const toFixedSafe = (value, digits) => {
    if (value === null || value === undefined) {
        return value;
    }
    const num = Number(value);
    if (isNaN(num)) {
        // return value;
        return '';
    }
    return num.toFixed(digits);
}